import React from 'react';
import { Link } from 'react-router-dom';
import withTracker from '../withTracker';

const MenuSelectionThanks = props => {
  const href = '/service/' + props.match.params.id;
  return (
    <div className="menu-selection">
      <div className="menu-selection-thanks">
        <h1 className="menu-selection-thanks__h1">
          Your menu has been submitted.
        </h1>
        <p className="menu-selection-thanks__p">
          We’re looking forward to cooking for you! Any changes to this menu
          must be made 48 hours before your service. Please feel free to contact
          us with any questions.
        </p>
        <Link
          className="menu-selection-thanks__cta btn btn--solid-blue"
          to={href}
        >
          View Service Detail
        </Link>
      </div>
    </div>
  );
};
export default withTracker(MenuSelectionThanks);



// WEBPACK FOOTER //
// ./src/components/menuSelection/MenuSelectionThanks.js